import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { AccountService } from './api/account.service';
import { AgentService } from './api/agent.service';
import { CallService } from './api/call.service';
import { CallbackService } from './api/callback.service';
import { ChatService } from './api/chat.service';
import { ClientService } from './api/client.service';
import { FileService } from './api/file.service';
import { MlsService } from './api/mls.service';
import { PropertyService } from './api/property.service';
import { PublicService } from './api/public.service';
import { PushService } from './api/push.service';
import { TransactionService } from './api/transaction.service';
import { UserService } from './api/user.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    AccountService,
    AgentService,
    CallService,
    CallbackService,
    ChatService,
    ClientService,
    FileService,
    MlsService,
    PropertyService,
    PublicService,
    PushService,
    TransactionService,
    UserService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
